import {ReportModel} from "@fedeltapointofsale/data-client";
import {BalanceTillSummaryReportData} from "./balance-till-summary-report.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class BalanceTillSummaryReportModel extends ReportModel<BalanceTillSummaryReportData> {
    constructor(injector: Injector ) {
        super(injector, BalanceTillSummaryReportData);
    }
}
